import { render } from "./KoruPdfDialog.vue?vue&type=template&id=b01aa7e6&ts=true"
import script from "./KoruPdfDialog.vue?vue&type=script&lang=ts"
export * from "./KoruPdfDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__